import { getURL } from "../utils/get-url";

export const wordPressRedirectUri = getURL("/callback/integration/wordpress");
